import { render } from "./PokCollapsibleBasic.vue?vue&type=template&id=1070d598"
import script from "./PokCollapsibleBasic.vue?vue&type=script&lang=js"
export * from "./PokCollapsibleBasic.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ron/balidev/pokus/gitlab_pokus_django/vueapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__